import dayjs, {Dayjs} from "dayjs";

import Member from "./Member";
import Community from "./Community";
import TransferStatusEnum from "../enums/TransferStatusEnum";
import MinimalManager from "./MinimalManager";

export default class Transfer {
    public id: string
    public firstName: string
    public lastName: string
    public telephone: string
    public reversedControl: boolean
    public member: Member
    public sourceCommunity: Community
    public targetCommunity: Community
    public status: TransferStatusEnum
    // public type: TransferTypeEnum
    public createdAt: Dayjs
    public updatedAt: Dayjs
    public amount: number
    public paidAt: Dayjs | null
    public sourceManager?: MinimalManager | null
    public targetManager?: MinimalManager | null
    public reason?: string | null

    constructor(data: any) {
        this.id = data.reference
        this.firstName = data.firstName
        this.lastName = data.lastName
        this.telephone = data.telephone
        this.reversedControl = data.reversedControl
        if(data.reason) {
            this.reason = data.reason
        }
        this.member = new Member(data.member)
        this.sourceCommunity = new Community(data.sourceCommunity)
        this.targetCommunity = new Community(data.targetCommunity)
        this.status = TransferStatusEnum.tryParse(data.status)
        // this.type = TransferTypeEnum.tryParse(data.type)
        this.createdAt = dayjs(data.createdAt)
        this.updatedAt = dayjs(data.updatedAt)
        this.amount = data.amount ?? null;
        this.paidAt = data.paidAt ? dayjs(data.paidAt) : null;
        if(data.sourceManager) {
            this.sourceManager = new MinimalManager(data.sourceManager)
        }
        if(data.targetManager) {
            this.targetManager = new MinimalManager(data.targetManager)
        }
    }
}
